import {kml} from '@tmcw/togeojson';

/*
 * Parses the KML polygon data into the ArcGIS-readable format
 */
const toRing = coordinates => coordinates.map(([x, y]) => [x, y]);
const getCoordinateRings = object => {
    if (!object || typeof object !== 'object') return [];

    return Object.entries(object).reduce((acc, [key, value]) => {
        if (key === 'coordinates' && value.length > 0) {
            acc.push(toRing(value[0]));
        } else {
            acc.push(...getCoordinateRings(value));
        }
        return acc;
    }, []);
};

const parseKMLPolygonData = kmlText => {
    const kmlData = (new DOMParser()).parseFromString(kmlText, 'text/xml');
    if (!kmlData) return null;
    const jsonData = kml(kmlData, {styles: true});
    if (!jsonData) return null;
    const rings = getCoordinateRings(jsonData);
    if (!rings) return null;
    return {
        type: 'polygon',
        rings,
    };
};

export default parseKMLPolygonData;
